import {TranslatedKeys} from 'shared/types/translated-keys';

export enum WhatsappDeliveryErrorEnum {
  pending = 'pending',
  resolved = 'resolved',
}
export interface WhatsappDeliveryErrorProps {
  id: string;
  phone: string;
  errorMessage: string;
  tries: number;
  createdAt: Date;
  updatedAt: Date;
  status: WhatsappDeliveryErrorEnum;
}

export const translatedWhatsappDeliveryErrorProps: TranslatedKeys<WhatsappDeliveryErrorProps> =
  {
    phone: 'Telefone',
    errorMessage: 'Mensagem',
    tries: 'Tentativas',
    createdAt: 'Primeira tentativa',
    updatedAt: 'Última tentativa',
    status: 'Status',
  };
